import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import { SwiperSlide, Swiper } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper/modules";

const LoginOnboarding = () => {
  const swiperConfig = {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    pagination: {
      clickable: true,
      el: ".swiper-pagination",
      renderBullet: (index: number, className: string) => {
        return `<span class="${className} custom-pagination-bullet"></span>`;
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    modules: [Pagination, Navigation],
  };

  return (
    <Grid item xs={12} md={6.5} sx={{ display: { xs: "none", sm: "none", md: "block" } }}>
      <Box
        sx={{
          backgroundColor: "#146ED2",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          height: "100%",
          borderRadius: "4px",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            bottom: "20%",
            textAlign: "center",
            width: "100%",
          }}
        >
          <Swiper {...swiperConfig}>
            <SwiperSlide>
              <Typography variant="h4" sx={{ fontSize: "30px", color: "white", fontWeight: 600 }}>
                Introducing MaviTrackr 1.0
              </Typography>
              <Typography variant="h5" sx={{ fontSize: "15px", color: "white", fontWeight: 500 }}>
                You asked and we listened! Faster and more
                <br />
                accurate performance reviews. Sign in to explore!
              </Typography>
            </SwiperSlide>
            <SwiperSlide>
              <Typography variant="h4" sx={{ fontSize: "30px", color: "white", fontWeight: 600 }}>
                Introducing MaviTrackr 1.0
              </Typography>
              <Typography variant="h5" sx={{ fontSize: "15px", color: "white", fontWeight: 500 }}>
                You asked and we listened! Faster and more
                <br />
                accurate performance reviews. Sign in to explore!
              </Typography>
            </SwiperSlide>
            <SwiperSlide>
              <Typography variant="h4" sx={{ fontSize: "30px", color: "white", fontWeight: 600 }}>
                Introducing MaviTrackr 1.0
              </Typography>
              <Typography variant="h5" sx={{ fontSize: "15px", color: "white", fontWeight: 500 }}>
                You asked and we listened! Faster and more
                <br />
                accurate performance reviews. Sign in to explore!
              </Typography>
            </SwiperSlide>
          </Swiper>
        </Box>
        <div className="swiper-pagination"></div>
        <div className="swiper-button-next"></div>
        <div className="swiper-button-prev"></div>
      </Box>
    </Grid>
  );
};

export default LoginOnboarding;
